import { IconArrowLeft } from "@tabler/icons-react";
import AppContext from "Context/appContext";
import Button from "components/Button";
import { DISPLAYING_PAGES } from "constants";
import "containers/Cart/index.css";
import { useContext, useEffect, useState } from "react";
import { useFormState } from "react-hook-form";
import { combineDateWithTime, isKeyValueEmpty } from "utils";
import IssueList from "./IssueList";
import ChevronRight from "components/icons/ChevronRight";
import ClipboardText from "components/icons/ClipboardText";
// import Accordion from "react-bootstrap/Accordion";
import axios from "axios";
import UrlServices from "../../services/Url";
import {
  isSubmittingLead,
  newSubmissionId,
  submitLead,
  SUBMIT_FAILED_MESSAGE,
} from "../../services/submitLead";

const Cart = () => {
  const {
    productCartDetail,
    currentState,
    formdata,
    setPrevState,
    products,
    progressState,
    setProgressState,
    prevState,
    appointmentDetail,
    loading,
    setLoading,
    setCurrentState,
    userSettings,
    productCartData,
    encryptionKey,
    reactHookFormData,
    buttonClicked,
    setButtonClicked,
    defaultStore,
    selectedStoreDetails,
    setCountryDetails,
    countryDetails,
    isBillable,
    bookingList,
    selectedCategory,
    isEmailVerified,
    emailVerificationToken,
    setEmailVerificationError,
    setSubmitError,
    submissionIdRef,
    // buttonLoader,
    // setButtonLoader
  } = useContext(AppContext);
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [activeKey, setActiveKey] = useState("0");

  const handleSelect = () => {
    setActiveKey((prevKey) => (prevKey === "0" ? "1" : "0"));
  };

  // Set previous state
  const setServiceArray = () => {
    setPrevState({ ...prevState, [progressState]: products });
  };

  // Function to detect if the user is on mobile or tablet
  const detectMobileOrTablet = () => {
    const screenWidth = window.innerWidth;
    setIsMobileOrTablet(screenWidth <= 768); // Adjust breakpoint as needed
  };

  // Toggle visibility of modal
  const toggleModal = () => {
    setIsViewOpen(!isViewOpen);
  };

  // Detect mobile or tablet on component mount
  useEffect(() => {
    fetchCountryDetails();
    detectMobileOrTablet();
    window.addEventListener("resize", detectMobileOrTablet);

    return () => {
      window.removeEventListener("resize", detectMobileOrTablet);
    };
  }, []);

  const fetchCountryDetails = async () => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_APPOINTMENT_PRO_API_URL}/${UrlServices.storeInfo}`,
      {
        q_: encryptionKey,
      }
    );
    setCountryDetails(data?.data);
  };

  const submitForm = async (clickedKey) => {
    if (isSubmittingLead()) return;
    // Where to put the customer back if the request fails.
    const returnTo = { progressState, currentState };
    // Guard: block submission if email verification is enabled but not verified
    if (userSettings?.enableEmailValidation && !isEmailVerified) {
      setEmailVerificationError("Please verify your email to continue.");
      setProgressState(4);
      setCurrentState(DISPLAYING_PAGES.FORM);
      return;
    }
    if (clickedKey === "appointments") {
      setButtonClicked("appointment");
      clickedKey = "appointments";
    } else {
      setButtonClicked("quote");
      clickedKey = "quote";
      setProgressState(6);
    }
    setCurrentState(DISPLAYING_PAGES.BOOKING);
    try {
      setLoading(true);
      setSubmitError("");
      // setButtonLoader(true);
      const services = productCartDetail?.services.map((item) => {
        const price =
          item.sale_price &&
          typeof item.sale_price === "string" &&
          item.sale_price.startsWith("0")
            ? item.retail_price
            : item.sale_price;
        return {
          rd_issue_id: item.id,
          name: item.name,
          price: item?.price ? item?.price : price,
        };
      });

      const formattedTime = combineDateWithTime(
        appointmentDetail?.date,
        appointmentDetail?.start
      );

      const categoryId = productCartDetail?.skipForOthers
        ? ""
        : userSettings?.isRDSync && productCartDetail?.category?.rd_category_id
        ? productCartDetail.category.rd_category_id
        : (isBillable && typeof productCartDetail?.services[0]?.category_id === 'string')
        ? productCartDetail.services[0].category_id
        : (isBillable && typeof productCartDetail.services[0]?.category_id === 'number')
        ? `${productCartDetail.services[0].category_id}`
        : selectedCategory?.rd_category_id
        ? selectedCategory.rd_category_id
        : productCartDetail?.brand?.category;
        
      const data = {
        device: productCartDetail?.category?.name || "",
        brand: isBillable ? "" : productCartDetail?.brand?.name || "others",
        model: isBillable ? "" :
          productCartDetail?.model?.name ||
          productCartData?.device_name ||
          formdata?.model,
          // sub_category: selectedCategory?.name || "",
        category_id: categoryId,
        manufacturer_id: productCartDetail?.skipForOthers ? "" : (userSettings?.isRDSync && !isBillable) ? productCartDetail?.brand.rd_manufacturer_id : isBillable ? "" : productCartDetail?.brand._id,
        rd_device_id: isBillable ? "" : productCartData?.rd_device_id,
        date: formattedTime || "",
        start_time:
          appointmentDetail?.start !== "" ? appointmentDetail?.start : "",
        end_time: appointmentDetail?.end !== "" ? appointmentDetail?.end : "",
        issues: services,
        store_id: selectedStoreDetails?.store_id || "",
        store_name: selectedStoreDetails?.store_name || "",
        first_name: formdata.firstName,
        last_name: formdata.lastName ? formdata.lastName : "",
        customer_email: formdata.email,
        customer_telephone: formdata.phone,
        customer_notes: formdata.notes,
        email_verification_token: emailVerificationToken || "",
        delivery_option: formdata?.option,
        delivery_status: formdata.status,
        total_price: productCartDetail?.totalPrice || 0,
        q_: encryptionKey,
        config_type: (isBillable && clickedKey === "quote") ? "billable_quote" : (isBillable && clickedKey === "appointments") ? "billable_appointments" : clickedKey,
      };
      // console.log(data);
      if (!submissionIdRef.current) submissionIdRef.current = newSubmissionId();
      const result = await submitLead({
        ...data,
        submission_id: submissionIdRef.current,
      });
      setLoading(false);
      // setButtonLoader(false);
      if (!result.ok) {
        // RB-19754: see AppManager's submitForm — no more silent failure, and
        // the selected device stays so a retry still carries the model.
        setSubmitError(result.message);
        setProgressState(returnTo.progressState);
        setCurrentState(returnTo.currentState);
        return;
      }
      submissionIdRef.current = null;
      setCurrentState(DISPLAYING_PAGES.COMPLETION);
      // const response = await res.json();
      // console.log(response);
      // setLoading(false);
      // setFormData({
      //   firstName: '',
      //   lastName: '',
      //   phone: '',
      //   email: '',
      //   notes: '',
      //   option: '',
      //   model: '',
      // })
      // reactHookFormData.reset()
    } catch (error) {
      setLoading(false);
      // setButtonLoader(false);
      setSubmitError(SUBMIT_FAILED_MESSAGE);
      setProgressState(returnTo.progressState);
      setCurrentState(returnTo.currentState);
      console.log(error);
    }
  };

  const { notes, ...formDataObj } = formdata;

  const { model, firstName, lastName, ...requiredFields } = formDataObj;

  const { errors: formErrors } = useFormState({
    control: reactHookFormData.control,
  });
  const { model: modelError, firstName: firstNameError, lastName: lastNameError, ...requiredFieldErrors } = formErrors;

  // Check if at least one name field is filled
  const isNameValid = firstName || lastName;
  
  // Check if all required fields are filled (phone, email, option)
  const isPhoneFilled = formdata.phone && formdata.phone.trim() !== '';
  const isEmailFilled = formdata.email && formdata.email.trim() !== '';
  const isOptionFilled = formdata.option && formdata.option.trim() !== '';
  
  const areRequiredFieldsFilled = isPhoneFilled && isEmailFilled && isOptionFilled;

  // Check if there are any validation errors
  const hasValidationErrors = Object.keys(requiredFieldErrors).length > 0 || 
    (formErrors && formErrors.nameRequired); // Check for the custom name validation error

  // Email verification check: if enabled, email must be verified
  const emailVerified = !userSettings?.enableEmailValidation || isEmailVerified;

  // Simplified validation logic
  const isFormValid = areRequiredFieldsFilled && isNameValid && !hasValidationErrors && emailVerified;

  // const isDisabled = !isFormValid;
  return (
    <>
      {/* Render the component normally on larger screens */}
      {!isMobileOrTablet && (
        <div
          className={`quote-cart ${
            progressState === 4 ? "rd-quote-h-[593px]" : ""
          } ${currentState === "COMPLETION" ? "" : "rd-quote-mt-4"} ${
            progressState === 4 ||
            progressState === 3 ||
            progressState === 5 ||
            progressState === 6
              ? "rd-quote-max-w-[336.5px] rd-quote-ml-0 rd-quote-pb-2"
              : ""
          }`}
        >
          <div className="quote-width">
            <div className="quote-cart-header">Details</div>
            {/* Item */}
            <div className="quote-cart-item">
              <div className="quote-cart-item-section">
                {productCartDetail?.brand?.picture && (
                  <div className="quote-cart-item-img">
                    <img
                      className="rd-quote-max-w-8 rd-quote-max-h-8"
                      alt="P"
                      src={productCartDetail?.brand?.picture}
                    />
                  </div>
                )}
                <div className="quote-cart-item-title ">
                  {/* Brand will not exist in billable categories */}
                  {!isBillable && <div className="quote-text3 rd-quote-truncate rd-quote-max-w-[180px]">
                    {productCartDetail?.brand?.name}
                  </div>}
                  <div className="quote-text1 rd-quote-font-normal rd-quote-truncate rd-quote-max-w-[180px]">
                    {productCartDetail?.model?.name ||
                      productCartData?.device_name ||
                      formdata?.model}
                  </div>
                </div>
              </div>
            </div>
            {/* issues header */}
            {productCartDetail?.services && (
              <>
                <div className="quote-cart-issue-header">
                  <div className="quote-text1 rd-quote-pb-1">
                    Issues({productCartDetail?.services?.length})
                  </div>
                  {/* <div className="rd-quote-gap-x-2 rd-quote-flex">
                    <span className="rd-quote-text-sm rd-quote-w-28 rd-quote-text-right rd-quote-text-teal-600 rd-quote-pb-2">View Issues</span>
                  </div> */}
                </div>
                <div
                  className={`quote-cart-issue-scroll
                  ${!userSettings?.isPricesEnabled && progressState === 4 ? "!rd-quote-max-h-[360px] rd-quote-pr-2" : ""}
                  ${userSettings?.isPricesEnabled && progressState === 4 ? "!rd-quote-max-h-[305px] rd-quote-pr-2" : ""}
                  ${!userSettings?.isPricesEnabled && progressState !== 4 ? "!rd-quote-max-h-[365px] rd-quote-pr-2.5" : ""}
                  ${userSettings?.isPricesEnabled && progressState !== 4 ? "!rd-quote-max-h-[315px] rd-quote-pr-2.5" : ""}
                  `}
                >
                  <IssueList />
                </div>
              </>
            )}
          </div>
          {/* bottom  */}
          <div className="rd-quote-flex rd-quote-flex-col rd-quote-justify-between">
            {/* {currentState === "FORM" && (
              <div className="rd-quote-flex rd-quote-flex-row rd-quote-rounded-md rd-quote-border rd-quote-p-3 rd-quote-border-gray-200 rd-quote-justify-start rd-quote-items-start rd-quote-inline-flex">
                <span className="rd-quote-mr-2 rd-quote-bg-amber-100">
                  <IconPercentage className="rd-quote-w-5 rd-quote-h-5 rd-quote-text-amber-700" />
                </span>
                <p className="rd-quote-text-gray-700 rd-quote-text-sm rd-quote-font-normal rd-quote-font-['SF Pro Text'] rd-quote-leading-tight">
                  {userSettings?.promotionalText}
                </p>
              </div>
            )} */}
            {userSettings?.isPricesEnabled && (
              <div
                className={`${
                  !productCartDetail?.totalPrice ||
                  productCartDetail?.totalPrice === undefined
                    ? "rd-quote-hidden"
                    : ""
                } rd-quote-flex rd-quote-flex-row rd-quote-justify-between rd-quote-items-center rd-quote-bg-gray-100 rd-quote-rounded rd-quote-px-2 rd-quote-mt-2`}
              >
                <p className="rd-quote-text-gray-800 rd-quote-mt-3 !rd-quote-text-center rd-quote-text-base rd-quote-font-normal rd-quote-leading-Normal">
                  Sub Total
                </p>
                <p className="rd-quote-text-gray-800 rd-quote-mt-3 !rd-quote-text-center rd-quote-text-base rd-quote-font-medium  rd-quote-leading-normal">
                  {/* $ */}
                  {countryDetails?.currency_symbol}
                  {productCartDetail?.totalPrice === undefined
                    ? 0
                    : productCartDetail?.totalPrice?.toFixed(2)}
                </p>
              </div>
            )}

            {currentState === DISPLAYING_PAGES.PRODUCT && !loading && (
              <Button
                disabled={!productCartDetail?.services?.length > 0}
                text={"Continue"}
                setServiceArray={setServiceArray}
              />
            )}
            {(currentState === DISPLAYING_PAGES.FORM ||
              currentState === DISPLAYING_PAGES.BOOKING) &&
              ((userSettings?.isQuoteEnabled && buttonClicked === "quote") ||
                (!userSettings?.isQuoteLocationsEnabled &&
                  progressState === 4 && userSettings?.isQuoteEnabled)) &&
              progressState > 3 &&
              !loading && (
                <Button
                  submit={() => submitForm("quote")}
                  text={"Get Quote"}
                  setWidth={true}
                  disabled={!isFormValid || (!defaultStore && progressState === 5)}
                />
              )}
            {(currentState === DISPLAYING_PAGES.FORM ||
              currentState === DISPLAYING_PAGES.BOOKING) &&
              userSettings?.isAppointmentEnabled &&
              currentState === DISPLAYING_PAGES.BOOKING &&
              buttonClicked === "appointment" &&
              !loading && (
                <Button
                  submit={() => submitForm("appointments")}
                  text={
                    progressState === 5 || progressState === 6
                      ? "Confirm Appointment"
                      : "Book an Appointment"
                  }
                  setWidth={
                    currentState === DISPLAYING_PAGES.BOOKING ? false : true
                  }
                  disabled={!isFormValid || (!defaultStore && progressState === 5) || (!appointmentDetail?.start && (progressState === 6 || (progressState === 5 && bookingList.length === 1)))}
                />
              )}
            {loading && <Button setWidth={true} text={"Loading.."} disabled />}
            {currentState === DISPLAYING_PAGES.FORM &&
              userSettings?.isQuoteEnabled &&
              userSettings?.isQuoteLocationsEnabled && (
                <Button
                  text={"Get Quote"}
                  setWidth={true}
                  submit={() => setButtonClicked("quote")}
                  disabled={!isFormValid}
                />
              )}
            {currentState === DISPLAYING_PAGES.FORM &&
              userSettings?.isAppointmentEnabled && (
                <Button
                  text={"Book an Appointment"}
                  setWidth={true}
                  typeA={true}
                  submit={() => setButtonClicked("appointment")}
                  disabled={!isFormValid}
                />
              )}
          </div>
        </div>
      )}

      {isMobileOrTablet && !isViewOpen && (
        <div className="quote-cart">
          <div className="quote-width">
            <div className="quote-cart-header rd-quote-flex rd-quote-gap-x-1 !rd-quote-mb-0">
              <ClipboardText 
                color={userSettings?.colourHex?.buttonAndBorderColor || '#0D9488'}
                className="rd-quote-w-[20px] rd-quote-h-[20px]"
              />
              {/* Show view button for mobile and tablet */}
              <button
                style={{ color: userSettings?.colourHex?.buttonAndBorderColor || '#0D9488' }}
                onClick={() => toggleModal()}
              >
                {isViewOpen ? "Hide" : "View"}
              </button>
              <ChevronRight 
                color={userSettings?.colourHex?.buttonAndBorderColor || '#0D9488'}
                className="rd-quote-w-[20px] rd-quote-h-[20px]"
              />
            </div>
          </div>

          <div className="rd-quote-flex rd-quote-flex-col rd-quote-justify-between">
            {/* {currentState === "FORM" && (
              <div className="rd-quote-flex rd-quote-flex-row rd-quote-rounded-md rd-quote-border rd-quote-p-3 rd-quote-border-gray-200 rd-quote-justify-start rd-quote-items-start rd-quote-inline-flex">
                <span className="rd-quote-mr-2 rd-quote-bg-amber-100">
                  <IconPercentage className="rd-quote-w-5 rd-quote-h-5 rd-quote-text-amber-700" />
                </span>
                <p className="rd-quote-text-gray-700 rd-quote-text-sm rd-quote-font-normal rd-quote-font-['SF Pro Text'] rd-quote-leading-tight">
                  Get{" "}
                  <span className="rd-quote-text-teal-600 rd-quote-text-sm rd-quote-font-semibold rd-quote-font-['SF Pro Text'] rd-quote-leading-tight">
                    10%
                  </span>{" "}
                  discount when you book online
                </p>
              </div>
            )} */}
            {userSettings?.isPricesEnabled && (
              <div
                className={`${
                  !productCartDetail?.totalPrice ||
                  productCartDetail?.totalPrice === undefined
                    ? "rd-quote-hidden"
                    : ""
                } rd-quote-flex rd-quote-flex-row rd-quote-justify-between rd-quote-items-center rd-quote-rounded rd-quote-px-2 rd-quote-mt-1`}
              >
                <p className="rd-quote-text-gray-800 rd-quote-mt-3 !rd-quote-text-center rd-quote-text-base rd-quote-font-normal rd-quote-leading-Normal">
                  Sub Total
                </p>
                <p className="rd-quote-text-gray-800 rd-quote-mt-3 !rd-quote-text-center rd-quote-text-base rd-quote-font-medium  rd-quote-leading-normal">
                  {countryDetails?.currency_symbol}
                  {productCartDetail?.totalPrice === undefined
                    ? 0
                    : productCartDetail?.totalPrice?.toFixed(2)}
                </p>
              </div>
            )}
          </div>
        </div>
      )}

      {isMobileOrTablet && isViewOpen && (
        <div className={`modal-container ${isViewOpen ? "show" : ""}`}>
          <div className="quote-cart-two">
            <div className="quote-width">
              <div className="quote-cart-header rd-quote-flex rd-quote-y-2">
                {/* for mobile and tablet */}
                {!isViewOpen && (
                  <button
                    className="rd-quote-text-teal-600"
                    onClick={() => toggleModal()}
                  >
                    Hide
                  </button>
                )}
                {isViewOpen && (
                  <span
                    className="quote-header-img rd-quote-cursor-pointer rd-quote-cursor-pointer"
                    onClick={() => toggleModal()}
                  >
                    <IconArrowLeft />
                  </span>
                )}
              </div>{" "}
              {/* Item */}
              <div className="quote-cart-item">
                <div className="quote-cart-item-section">
                  {productCartDetail?.model?.picture && (
                    <div className="quote-cart-item-img">
                      <img
                        className="rd-quote-max-w-8 rd-quote-max-h-8"
                        alt="P"
                        src={productCartDetail?.model?.picture}
                      />
                    </div>
                  )}
                  <div className="quote-cart-item-title ">
                    <div className="quote-text3 rd-quote-truncate rd-quote-max-w-[230px]">
                      {productCartDetail?.brand?.name}
                    </div>
                    <div className="quote-text1 rd-quote-font-normal">
                      {productCartDetail?.model?.name ||
                        productCartData?.device_name ||
                        formdata?.model}
                    </div>
                  </div>
                </div>
              </div>
              {/* issues header */}
              {productCartDetail?.services && (
                <>
                  <div className="rd-quote-gap-x-2 rd-quote-flex">
                    <div className="rd-quote-flex rd-quote-flex-col rd-quote-w-full rd-quote-border-none">
                      <div className="quote-cart-issue-header rd-quote-mt-0 rd-quote-items-center">
                        <div className="quote-text1">
                          Issues({productCartDetail?.services?.length})
                        </div>
                      </div>
                      <div className="quote-cart-issue-scroll rd-quote-pt-0 rd-quote-pl-0 rd-quote-pb-0 rd-quote-pr-2">
                        <IssueList />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            {/* bottom  */}
            <div className="rd-quote-flex rd-quote-flex-col rd-quote-justify-between">
              {/* {currentState === "FORM" && (
                <div className="rd-quote-flex rd-quote-flex-row rd-quote-rounded-md rd-quote-border rd-quote-p-3 rd-quote-border-gray-200 rd-quote-justify-start rd-quote-items-start rd-quote-inline-flex">
                  <span className="rd-quote-mr-2 rd-quote-bg-amber-100">
                    <IconPercentage className="rd-quote-w-5 rd-quote-h-5 rd-quote-text-amber-700" />
                  </span>
                  <p className="rd-quote-text-gray-700 rd-quote-text-sm rd-quote-font-normal rd-quote-font-['SF Pro Text'] rd-quote-leading-tight">
                    {userSettings?.promotionalText}
                  </p>
                </div>
              )} */}
              {userSettings?.isPricesEnabled && (
                <div
                  className={`${
                    !productCartDetail?.totalPrice ||
                    productCartDetail?.totalPrice === undefined
                      ? "rd-quote-hidden"
                      : ""
                  } rd-quote-flex rd-quote-flex-row rd-quote-justify-between rd-quote-items-center rd-quote-rounded rd-quote-px-2 rd-quote-mt-2`}
                >
                  <p className="rd-quote-text-gray-800 rd-quote-mt-3 !rd-quote-text-center rd-quote-text-base rd-quote-font-normal rd-quote-leading-Normal">
                    Sub Total
                  </p>
                  <p className="rd-quote-text-gray-800 rd-quote-mt-3 !rd-quote-text-center rd-quote-text-base rd-quote-font-medium  rd-quote-leading-normal">
                    {/* $ */}
                    {countryDetails?.currency_symbol}
                    {productCartDetail?.totalPrice === undefined
                      ? 0
                      : productCartDetail?.totalPrice?.toFixed(2)}
                  </p>
                </div>
              )}
              {currentState === DISPLAYING_PAGES.PRODUCT && !loading && (
                <div onClick={() => setIsViewOpen(false)}>
                <Button
                  disabled={!productCartDetail?.services?.length > 0}
                  text={"Continue"}
                  setServiceArray={setServiceArray}
                />
                </div>
              )}
              <div className="quote-row-justify rd-quote-gap-x-2">
                {(currentState === DISPLAYING_PAGES.FORM ||
                  currentState === DISPLAYING_PAGES.BOOKING) && progressState !== 5 &&
                  ((userSettings?.isQuoteEnabled && buttonClicked === "quote") ||
                  (!userSettings?.isQuoteLocationsEnabled &&
                    progressState === 4 && userSettings?.isQuoteEnabled)) &&
                  progressState > 3 &&
                  !loading && (
                    <div onClick={() => setIsViewOpen(false)} className="rd-quote-w-full">
                    <Button
                      submit={() => submitForm("quote")}
                      text={"Get Quote"}
                      setWidth={true}
                      disabled={!isFormValid}
                    />
                    </div>
                  )}
                {(currentState === DISPLAYING_PAGES.FORM ||
                  currentState === DISPLAYING_PAGES.BOOKING) &&
                  userSettings?.isAppointmentEnabled &&
                  currentState === DISPLAYING_PAGES.BOOKING &&
                  progressState !== 5 &&
                  buttonClicked === "appointment" &&
                  !loading && (
                    <div onClick={() => setIsViewOpen(false)} className="rd-quote-w-full">
                    <Button
                      submit={() => submitForm("appointments")}
                      text={"Confirm Appointment"}
                      setWidth={
                        currentState === DISPLAYING_PAGES.BOOKING ? false : true
                      }
                      disabled={!isFormValid}
                    />
                    </div>
                  )}
                {loading && (
                  <Button setWidth={true} text={"Loading.."} disabled />
                )}
                {currentState === DISPLAYING_PAGES.FORM &&
                  userSettings?.isQuoteEnabled &&
                  userSettings?.isQuoteLocationsEnabled && (
                    <div onClick={() => setIsViewOpen(false)} className="rd-quote-w-full">
                    <Button
                      text={"Get Quote"}
                      setWidth={true}
                      submit={() => setButtonClicked("quote")}
                      disabled={!isFormValid}
                    />
                    </div>
                  )}
                {currentState === DISPLAYING_PAGES.FORM &&
                  userSettings?.isAppointmentEnabled && (
                    <div onClick={() => setIsViewOpen(false)} className="rd-quote-w-full">
                    <Button
                      text={"Book an Appointment"}
                      setWidth={true}
                      typeA={true}
                      submit={() => setButtonClicked("appointment")}
                      disabled={!isFormValid}
                    />
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Cart;
